// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2xFOQ","loaderOuter":"PageOverlayLoader_loaderOuter__2jbh1"};